const products = [
  {
    id: "vpn",
    type: "Security",
    name: "FORMO VPN",
    description:
      "Military-grade encryption and blazing-fast servers across 60+ countries. Protect your privacy, bypass restrictions, and browse with complete confidence on any iOS device.",
    features: ["AES-256 Encryption", "No-Log Policy", "60+ Server Locations", "Kill Switch"],
    image:
      "https://public.readdy.ai/ai/img_res/3759f1719dac39052cebfd17a30c4bf6.jpg",
  },
  {
    id: "cleaner",
    type: "Optimization",
    name: "FORMO Cleaner",
    description:
      "Intelligently scans and removes junk files, duplicate photos, and unnecessary caches. Keep your iPhone running at peak performance with one smart tap.",
    features: ["Smart Junk Scan", "Duplicate Finder", "Memory Boost", "Storage Insights"],
    image:
      "https://readdy.ai/api/search-image?query=clean%20iOS%20cleaner%20app%20interface%20on%20iPhone%2C%20light%20mode%20UI%20with%20progress%20circles%20and%20storage%20graphs%2C%20minimalist%20design%2C%20premium%20mobile%20app%20screenshot%20style%2C%20simple%20white%20background%2C%20professional%20product%20photography&width=600&height=700&seq=product-cleaner-formo-001&orientation=portrait",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full py-28 md:py-36 px-6 md:px-12 lg:px-20 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-4">
          <div>
            <span className="block text-xs uppercase tracking-widest text-gray-400 font-medium mb-4">
              Our Products
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight">
              Crafted for the
              <br />
              iOS Ecosystem
            </h2>
          </div>
          <p className="text-base text-gray-400 max-w-xs md:text-right leading-relaxed">
            Each product is designed from the ground up to feel native, fast, and effortless on Apple devices.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="group rounded-2xl overflow-hidden bg-gray-50 flex flex-col transition-transform duration-300 hover:-translate-y-1"
            >
              {/* Image */}
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-1">
                <span className="text-xs uppercase tracking-widest text-gray-400 font-medium mb-2">
                  {product.type}
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{product.name}</h3>
                <p className="text-sm text-gray-500 leading-relaxed mb-6">{product.description}</p>

                {/* Feature Tags */}
                <div className="flex flex-wrap gap-2 mt-auto">
                  {product.features.map((f) => (
                    <span
                      key={f}
                      className="px-3 py-1 rounded-full bg-white border border-gray-200 text-xs text-gray-600 font-medium"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
